<template>
  <Modal
    no-footer
    title="Payment Details"
    class-name="invoice-accounting-modal"
    @hide-modal="$emit('hide-modal')"
  >
    <div class="section-spacing-10">
      <div>
        <div>
          <strong>Notes:</strong>
        </div>
        <div>
          {{ record.notes || "--" }}
        </div>
        <div>
          <strong>Processor Tx ID:</strong>
        </div>
        <div>
          {{ record.processor_tx_id || "--" }}
        </div>
      </div>
      <div v-if="showCheckInfo">
        <div>
          <strong>DL Number:</strong>
        </div>
        <div>
          {{ record.check_dl_number || "--" }}
        </div>
      </div>
      <div v-if="showCheckInfo">
        <div>
          <strong>DL State:</strong>
        </div>
        <div>
          {{ record.check_dl_state || "--" }}
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from "@/components/Modal.vue";
export default {
  components: {
    Modal
  },
  props: {
    record: {
      type: Object,
      default: () => null
    }
  },
  emits: ["hide-modal"],
  computed: {
    showCheckInfo() {
      return this.record.check_dl_number || this.record.check_dl_state;
    }
  }
};
</script>
